import { type ISearchParam } from '@interface/ICommon';
import { type IDicItemList, type IDicParams } from '@interface/IItemDic';
import {Trans, useTranslation} from 'react-i18next';
import { DicItem } from './DicItem';
import {DicItemLineageClassic} from "./DicItemLineageClassic";

export const ItemLisLineageClassic = ({
    listData,
    priceListParam,
    loading,
    params,
}: {
    listData: IDicItemList['contents'] | undefined;
    priceListParam: ISearchParam;
    loading: boolean;
    params: IDicParams;
}) => {
    if (!listData) return null;

    const { t } = useTranslation();

    const getSearchType = () => {
        const path = location.pathname;
        const match = path.match(/\/info\/(\w+)/);
        return match ? match[1] : 'item';
    };

    const searchType = getSearchType();

    return (
        <section className="gameinfo-result__list">
            {loading && (
                <div className="gameinfo-loader is-show">
                    <span className="loader" />
                </div>
            )}

            {listData.length < 1 && (
                <div className="nodata" style={{ display: 'block' }}>
                    <Trans components={{ i: <i />, div: <div /> }} i18nKey={setNoResultandFavs(params)} />
                </div>
            )}

            <div className="ui-table" data-tabletype={searchType} style={{ display: listData.length < 1 ? 'none' : 'block' }}>
                <div className="tablehead">
                    {searchType === 'item' && (
                        <div className="tablerow">
                            <div className="tablecell"></div>
                            <div className="tablecell">{t('common.itemname')}</div>
                            <div className="tablecell">{t('common.category')}</div>
                            <div className="tablecell">{t('common.option')}</div>
                        </div>
                    )}
                    {searchType === 'spell' && (
                        <div className="tablerow spell">
                            <div className="tablecell"></div>
                            <div className="tablecell">{t('common.spellname')}</div>
                            <div className="tablecell">{t('common.class')}</div>
                            <div className="tablecell">{t('common.catalyst')}</div>
                            <div className="tablecell">{t('common.duration')}</div>
                            <div className="tablecell">{t('common.desc')}</div>
                        </div>
                    )}
                    {searchType === 'monster' && (
                        <div className="tablerow monster">
                            <div className="tablecell"></div>
                            <div className="tablecell">{t('common.monstername')}</div>
                            <div className="tablecell">{t('common.region')}</div>
                            <div className="tablecell">{t('common.level')}</div>
                            <div className="tablecell">{t('common.attr')}</div>
                            <div className="tablecell">{t('common.droplist')}</div>
                        </div>
                    )}
                </div>
                <div className="tablebody">
                    {listData.map((it, idx) => (
                        <DicItemLineageClassic
                            key={idx + '_' + it.id + it.favorite.toString() + it.grade + params.paramPage + params.paramQuery}
                            it={it}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

const setNoResultandFavs = (params: IDicParams) => {
    const { paramFavorite } = params;
    let result = '';
    if (paramFavorite !== 'true') {
        result = 'common.noresultsitemprice';
    } else if (paramFavorite === 'true') {
        result = 'common.noresultsfavs';
    }
    return result;
};
